import React from 'react';
import styled from '@emotion/styled';
import Chip from 'ui/elements/Chip';
import { quarterSpacing, halfSpacing } from 'ui/theme/themeConstants';

const Container = styled.div`
  min-height: 24px; // Matches chip height
  display: flex;
  align-items: center;
  gap: ${quarterSpacing};
  flex-wrap: wrap;
  margin-bottom: ${halfSpacing};
`;

export interface ActiveFilter {
  id: string;
  label: string;
  value: string;
  onRemove: () => void;
  color?: 'yellow-light' | 'yellow' | 'blue-light';
  customLabel?: string;
}

interface ActiveFiltersProps {
  filters: ActiveFilter[];
}

export default function ActiveFilters({ filters }: ActiveFiltersProps) {
  // Always render container to reserve space, even when no active filters
  return (
    <Container>
      {filters.map((filter) => (
        <Chip
          key={filter.id}
          color={filter.color ?? 'blue-light'}
          label={filter.customLabel ?? `${filter.label} is ${filter.value}`}
          onDelete={filter.onRemove}
        />
      ))}
    </Container>
  );
}

